import { useRoutes } from "react-router-dom";
import UserDashboardLayout from "../Controller/userController";
import UserDashboard from "../UsersPage/UserDashboard";
import EventSlider from "../UsersPage/Test";
import Events from "../UsersPage/Events";
import EventsDetails from "../UsersPage/EventDetails";
import Recordings from "../UsersPage/Recordings";
import RecordingDetails from "../UsersPage/RecordingDetails";
import Listen from "../UsersPage/Listen";
import Stats from "../UsersPage/Stats";
import Setting from "../UsersPage/Settings";
import VideoChat from "../UsersPage/Test";
import GoLive from "../UsersPage/Golive";
import SingUp from "../LoginPages/SingUp";
import Login from "../LoginPages/Login";
import ForgetPassword from "../LoginPages/ForgetPassword";
import VerificationForget from "../LoginPages/VerificationForget";
import EmailVerification from "../LoginPages/EmailVerification";
import General from "../Layouts/general";
import Home from "../GuestPages/Home";
import Pricing from "../GuestPages/Pricing";
import Company from "../GuestPages/Company";
import Explore from "../GuestPages/Explore";
import AudioOnly from "../UsersPage/LivePath/AudioOnly";
import ListeningLive from "../UsersPage/LivePath/ListeningLive";
import PreSignUp from "../LoginPages/PreSignUp";
import PreSignIn from "../LoginPages/PreSignIn";
import ListenerLogin from "../LoginPages/ListenerLogIn";
import ListenerDashboardLayout from "../Controller/listenerController";
import ListenerEvents from "../ListenerPages/ListenerEvent";
import ListenerEventsDetails from "../ListenerPages/ListenerEventDetails";
import ParticipantsLiveStreaming from "../UsersPage/SecondTest";
import RecordedSound from "../UsersPage/ThitdTest.js";
import Participant from "../UsersPage/FourText.js";
import Moderator from "../UsersPage/Moderator.js";
import NonUserListener from "../ListenerPages/NonUserListener.js";
import UserListener from "../ListenerPages/UserListener.js";
import ListenDetails from "../UsersPage/ListenDetails";
import PricingList from "../UsersPage/Pricing.js";






export default function Routess() {
    return(
        useRoutes(
            [
                {
                    path : "/",
                    element: <General />,
                    children:  [
                        {path: "/", element: <Home />},
                        {path: "/pricing", element: <Pricing />},
                        {path: "/company", element: <Company />},
                        {path: "/explore", element: <Explore />},
                    ]
                },
                {
                    path: "/users",
                    element: <UserDashboardLayout />,
                    children: [
                        {path: "/users/dashboard", element: <UserDashboard />},
                        {path: "/users/test", element: <VideoChat />},
                        {path: "/users/listen-details/:id", element: <ListenDetails />},
                        {path: "/users/test-two", element: <ParticipantsLiveStreaming />},
                        {path: "/users/test-three", element: <RecordedSound />},
                        {path: "/users/test-four", element: <Participant />},
                        {path: "/users/events", element: <Events />},
                        {path: "/users/eventsdetails/:id", element: <EventsDetails />},
                        {path: "/users/recordings", element: <Recordings />},
                        {path: "/users/recordingDetails", element: <RecordingDetails />},
                        {path: "/users/listen", element: <Listen />},
                        {path: "/users/stats", element: <Stats />},
                        {path: "/users/moderator", element: <Moderator />},
                         {path: "/users/pricing", element: <PricingList />},
                        {path: "/users/settings", element: <Setting />},
                    ]
                },
                {
                    path: "/listener",
                    element: <ListenerDashboardLayout />,
                    children: [
                        {path: "/listener/dashboard", element: <ListenerEvents />},
                        {path: "/listener/events", element: <ListenerEvents />},
                        {path: "/listener/settings", element: <Setting />},
                        {path: "/listener/eventsdetails/:id", element: <ListenerEventsDetails />},

                      
                    ]
                },
                {path: "/liveshow/:channelId/:eventId", element: <GoLive />},
                {path: "/liveshow/audio-only", element: <AudioOnly />},
                {path: "/preSignIn", element: <PreSignIn />},
                {path: "/preSignUp", element: <PreSignUp />},
                {path: "/signUp", element: <SingUp />},
                {path: "/login", element: <Login />},
                {path: "/login/listener", element: <ListenerLogin />},
                {path: "/forgetpassword", element: <ForgetPassword />},
                {path: "/forgetpasswordverification", element: <VerificationForget />},
                {path: "/emailverification", element: <EmailVerification />},
                {path: "/live/listening", element: <ListeningLive />},
                 {path: "/non-user-listner", element: <NonUserListener />},
                {path: "/listener/live/:channelId/:eventId", element: <UserListener />},
                {path: "/live/listening/:channelId/:eventId", element: <ListeningLive />},
            ]
        )
    )
}